<template>
  <div>
    <vs-alert color="danger" title="Product Not Found" :active.sync="user_not_found">
      <span>Product record not found. </span>
    </vs-alert>

    <div id="user-data">
      <div class="vx-row" id="page-user-view">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card class="mb-base">
            <table v-if="product_data">
              <tr>
                <td class="font-semibold">Internal ID</td>
                <td>#{{ this.$route.params.productid }}</td>
              </tr>
              <tr v-if="product_data">
                <td class="font-semibold">Category</td>
                <td>{{ product_data.category }}</td>
              </tr>
              <tr v-if="product_data">
                <td class="font-semibold">Product</td>
                <td>{{ product_data.product }}</td>
              </tr>
              <tr v-if="product_data">
                <td class="font-semibold">Volume Unit</td>
                <td>{{ Number(product_data.volume).toFixed(4) }} m3</td>
              </tr>
              <tr>
                <td class="font-semibold"></td>
              </tr>
              <tr>
                <td class="font-semibold">Current Quantity</td>
                <td>
                  {{ Number(current_stock).toFixed(4) }} {{ product_data.uom }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Projected Quantity</td>
                <td>
                  {{ Number(current_stock_quotation).toFixed(4) }}
                  {{ product_data.uom }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold"></td>
              </tr>
              <tr v-if="product_data">
                <td class="font-semibold">Current Volume</td>
                <td>{{ getQuantity(product_data.volume).toFixed(4) }} m3</td>
              </tr>
              <tr v-if="product_data">
                <td class="font-semibold">Projected Volume</td>
                <td>
                  {{ getProjQuantity(product_data.volume).toFixed(4) }} m3
                </td>
              </tr>
            </table>
            <vs-button v-if="product_data && canSeePotentialClients" class="mt-4" icon-pack="feather" icon="icon-users"
              @click="potentialClientsPopup = true">Potential clients
            </vs-button>
          </vx-card>
        </div>
        <div v-if="displayGraph" class="vx-col lg:w-1/2 w-full">
          <vx-card title="Stock Evolution in m3 (Month by Month)" class="mb-base">
            <template slot="actions">
              <vs-select v-model="graphMonths" class="w-32">
                <vs-select-item v-for="r in graphRanges" :key="r.value" :value="r.value" :text="r.text" />
              </vs-select>
            </template>
            <e-charts autoresize :options="line" theme="ovilia-green" ref="line" auto-resize />
          </vx-card>
        </div>
      </div>
      <div class="vx-row" v-if="stock_quotation_data && stock_quotation_data.length > 0">
        <div class="vx-col w-full">
          <vx-card title="Approved Quotations" class="mb-base">
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table ref="table" :data="stock_quotation_data">
                  <template slot="thead">
                    <vs-th sort-key="category">Date</vs-th>
                    <vs-th sort-key="Product">Type</vs-th>
                    <vs-th sort-key="username">Quantity</vs-th>
                    <vs-th sort-key="username">Volume (m3)</vs-th>
                    <vs-th sort-key="username">Unit of Measure</vs-th>
                    <vs-th>Action</vs-th>
                  </template>

                  <template>
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in stock_quotation_data">
                        <vs-td>{{ tr.date }}</vs-td>
                        <vs-td v-if="tr.OperationCtg === 'Sale'"><vs-chip color="danger">Sale</vs-chip></vs-td>
                        <vs-td v-else-if="tr.OperationCtg === 'Reception'"><vs-chip
                            color="success">Reception</vs-chip></vs-td>
                        <vs-td v-else><vs-chip color="warning">{{
                          tr.OperationCtg
                            }} &nbsp;&nbsp;&nbsp; <img height="16px" v-if="tr.clientlocation == 'BE'"
                              src="@/assets/images/flags/BE.png" alt="BE">
                            <img height="16px" v-else-if="tr.clientlocation == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT">
                            <img height="16px" v-else-if="tr.clientlocation == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL">
                            <img height="16px" v-else-if="tr.clientlocation == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH">
                            <img height="16px" v-else-if="tr.clientlocation == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE">
                            <img height="16px" v-else-if="tr.clientlocation == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES">
                            <img height="16px" v-else-if="tr.clientlocation == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR">
                            <img height="16px" v-else-if="tr.clientlocation == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT">
                            <img height="16px" v-else-if="tr.clientlocation == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU">
                            <img height="16px" v-else-if="tr.clientlocation == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO">
                            <img height="16px" v-else-if="tr.clientlocation == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB">
                            <img height="16px" v-else src="@/assets/images/flags/UE.png" alt="EU">&nbsp;{{ tr.client }}
                            &#8594; {{ tr.place }}</vs-chip></vs-td>
                        <vs-td>{{ Number(tr.quantity).toFixed(4) }}</vs-td>
                        <vs-td>{{ Number(tr.volume).toFixed(4) }}</vs-td>
                        <vs-td>{{ tr.uom }}</vs-td>
                        <vs-td>
                          <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="openOperation(
                            tr.idoperation,
                            tr.OperationCtg.toLowerCase()
                          )
                            " />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>

      <div class="vx-row" v-if="operation_data && operation_data.length > 0">
        <div class="vx-col w-full">
          <vx-card title="Operation History" class="mb-base">
            <vs-button style="float: right" class="mr-8 mb-4" @click="copyToClipboard('thistable')">Copy To
              Clipboard</vs-button>
            <template>
              <div id="data-list-list-view" class="data-list-container">
                <vs-table id="thistable" ref="table" :data="operation_data">
                  <template slot="thead">
                    <vs-th sort-key="category">Date</vs-th>
                    <vs-th sort-key="Product">Type</vs-th>
                    <vs-th sort-key="Aviz">Aviz No</vs-th>
                    <vs-th sort-key="username">Quantity</vs-th>
                    <vs-th sort-key="username">Unit of Measure</vs-th>
                    <vs-th sort-key="username">Volume (m3)</vs-th>
                    <vs-th sort-key="username">Weight (t)</vs-th>
                    <vs-th sort-key="created">Created Date</vs-th>
                    <vs-th>Action</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td><a :href="writeLink(tr.idoperation, tr.OperationCtg.toLowerCase())">{{ tr.date
                            }}</a></vs-td>
                        <vs-td v-if="tr.OperationCtg === 'Invoice'"><vs-chip color="danger">Sale &#8594;
                            {{ tr.client }} {{ tr.invoice_no }}</vs-chip>
                        </vs-td>
                        <vs-td v-else-if="tr.OperationCtg === 'Reception'"><vs-chip color="success">Reception &#8592; {{
                          tr.client
                            }} {{ tr.name }}</vs-chip></vs-td>
                        <vs-td v-else><vs-chip color="warning">{{
                          tr.OperationCtg
                            }} {{ tr.name }} </vs-chip>


                        </vs-td>
                        <vs-td><small>{{ tr.sumal_aviz_nr }}</small></vs-td>
                        <vs-td>{{ Number(tr.quantity).toFixed(4) }}</vs-td>
                        <vs-td>{{ tr.uom }}</vs-td>
                        <vs-td>{{ Number(tr.volume).toFixed(4) }}</vs-td>
                        <vs-td v-if="tr.weight">{{ Number(tr.weight).toFixed(4) }}</vs-td>
                        <vs-td v-else>N/A</vs-td>
                        <vs-td>{{ tr.created }}</vs-td>
                        <vs-td>
                          <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="openOperation(
                            tr.idoperation,
                            tr.OperationCtg.toLowerCase()
                          )
                            " />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card v-if="markers.length > 0" title="Sales Location" class="mb-base">
            <template>
              <GmapMap :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 400px">
                <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="true"
                  :draggable="false" @click="center = m" />
              </GmapMap>
            </template>
          </vx-card>
        </div>
      </div>
    </div>

    <potential-clients-popup v-if="canSeePotentialClients" :active.sync="potentialClientsPopup"
      :idproduct="Number($route.params.productid)" />
  </div>
</template>

<script>
import moduleStockList from "@/store/stock/moduleOperationList.js";
import moment from "moment";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import theme from "./theme.json";
import axios from "@/axios.js";
import PotentialClientsPopup from "@/components/potential-interest/PotentialClientsPopup.vue";

ECharts.registerTheme("ovilia-green", theme);

export default {
  data() {
    return {
      displayGraph: true,
      graphMonths: 24,
      graphRanges: [
        { value: 6, text: "6 months" },
        { value: 12, text: "1 year" },
        { value: 24, text: "2 years" },
        { value: 48, text: "4 years" },
      ],
      product_data: null,
      operation_data: null,
      stock_quotation_data: null,
      user_not_found: false,
      line: {},
      current_stock: null,
      current_stock_quotation: null,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      potentialClientsPopup: false,
    };
  },
  components: {
    ECharts,
    PotentialClientsPopup,
  },
  watch: {
    graphMonths() {
      this.getGraphData();
    },
  },
  computed: {
    // Même périmètre que l'API (moderator/admin) : les autres rôles recevraient un 403.
    canSeePotentialClients() {
      const roles = (localStorage.getItem("login-roles") || "").toLowerCase();
      return roles.includes("admin") || roles.includes("moderator");
    },
  },
  methods: {
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$vs.notify({
        color: "success",
        text:
          "Data copied to Clipboard!"
      });
    },
    getQuantity(volumeunitaire) {
      return this.current_stock * volumeunitaire;
    },
    getProjQuantity(volumeunitaire) {
      return this.current_stock_quotation * volumeunitaire;
    },
    async GetCurrentStock() {
      axios
        .get("/getstocktoday/" + this.$route.params.productid)
        .then((response) => {
          this.current_stock = response.data;
        });
    },
    async GetCurrentStockWithQuotation() {
      axios
        .get("/getprojectiontoday/" + this.$route.params.productid)
        .then((response) => {
          this.current_stock_quotation = response.data;
        });
    },
    async GetMapOfSale() {
      axios
        .get("/getproductsoldmap/" + this.$route.params.productid)
        .then((response) => {
          this.markers = response.data;
        });
    },
    // Stock in m3 at the end of each month (last point = today) over the selected period.
    async getGraphData() {
      try {
        const { data } = await axios.get(
          "/getstockmonthly/" + this.$route.params.productid,
          { params: { months: this.graphMonths } }
        );
        const points = Array.isArray(data) ? data : [];
        this.displayGraph = points.length > 0;
        const snapDates = points.map((p) => moment(p.date, "YYYY-MM-DD"));
        const dateList = snapDates.map((d) => d.format("MMM YYYY"));
        const valueList = points.map((p) => Number(p.stock) || 0);
        this.line = {
          // Make gradient line here
          visualMap: [
            {
              show: false,
              type: "continuous",
              seriesIndex: 0,
              min: 0,
              max: 400,
            },
          ],
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              const i = params[0].dataIndex;
              return (
                "Stock on " + snapDates[i].format("DD MMM YYYY") +
                "<br/>" + valueList[i].toFixed(4) + " m3"
              );
            },
          },
          xAxis: {
            data: dateList,
          },
          yAxis: {
            splitLine: { show: false },
          },
          series: {
            type: "line",
            showSymbol: false,
            data: valueList,
          },
        };
      } catch (e) {
        console.error(e);
        this.displayGraph = false;
      }
    },
    openOperation(id, type) {
      this.$router.push({ path: "/" + type + "/" + id });
    },
    writeLink(id, type) {
      return "/web/" + type + "/" + id
    },
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    moment: function () {
      return moment();
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
  },
  created() {
    this.$vs.loading();
    // Register Module UserManagement Module
    if (!moduleStockList.isRegistered) {
      this.$store.registerModule("stockList", moduleStockList);
      moduleStockList.isRegistered = true;
    }

    const productId = this.$route.params.productid;
    this.$store
      .dispatch("stockList/fetchStock", productId)
      .then((res) => {
        this.product_data = res.data;
        //this.GetMapOfSale();
        this.GetCurrentStock();
        this.GetCurrentStockWithQuotation();
        this.getGraphData();
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
    this.$store
      .dispatch("stockList/fetchStockOperationList", productId)
      .then((res) => {
        this.operation_data = res.data;

        this.$store
          .dispatch("stockList/fetchStockQuotation", productId)
          .then((res) => {
            this.stock_quotation_data = res.data;
            this.$vs.loading.close();
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });

  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

/*
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}*/

// #accoun*t-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}

/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
